import React, { useCallback, useEffect, useState } from "react";
import { TagSelect } from "../inputs/SelectBox";
import DropdownButton from "app/components/DropdownButton";
import styles from "./styles.module.scss";
import CheckBox from "../inputs/CheckBox";
import { filterStateDataType } from "../Filter";
import { useTranslation } from "react-i18next";

const DEFAULT_TYPES = ["image", "video", "audio", "datafile"];

interface Props {
  onFilterChange: (filter: any) => void;
  disabled?: boolean;
}

const filterLabels = [
  { value: "image", label: "Images" },
  { value: "video", label: "Videos" },
  { value: "audio", label: "Audio" },
  { value: "datafile", label: "Documents" },
];

const FileUploadFilter = ({ onFilterChange, disabled }: Props) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState<{
    tags?: string[];
    type?: string[];
  }>({ type: DEFAULT_TYPES });

  const onTagsChange = useCallback(
    (tags: any) => {
      const tagNames = tags.map((item: { name: string }) => item.name);

      setFilters({
        ...filters,
        tags: tagNames,
      });
      onFilterChange({
        ...filters,
        tags: tagNames,
      });
    },
    [filters, onFilterChange],
  );

  const toggleMediaType = useCallback(
    (dataType: filterStateDataType) => {
      if (!disabled) {
        let newTypes = Array.isArray(filters.type) ? [...filters.type] : [];
        if (newTypes.includes(dataType)) {
          newTypes = newTypes.filter((type) => type !== dataType);
        } else {
          newTypes.push(dataType);
        }
        const newFilters = {
          ...filters,
          type: newTypes,
        };
        onFilterChange(newFilters);
        setFilters(newFilters);
      }
    },
    [disabled, filters, onFilterChange],
  );

  useEffect(() => {
    return () => {
      setFilters({});
    };
  }, []);

  const DropdownContent = () => (
    <div className={`${styles.btn_content} btn btn-secondary-outline`}>
      {t("All Types")}
      <i className="ico ico-chevron" />
    </div>
  );

  return (
    <div className={styles.container}>
      <TagSelect
        isCreatable={false}
        isClearable
        isMulti
        onChange={onTagsChange}
        placeholder={t("Filter By Tags")}
      />
      <DropdownButton
        dropdownWrapperClass={styles.dropdown_content}
        btnClassName={styles.filter_btn}
        btnContent={<DropdownContent />}
      >
        <div className={styles.dropdown_container}>
          <p className={styles.filter_title}>Filter By</p>
          <div className={styles.checkbox_wrapper}>
            {filterLabels.map((item) => (
              <CheckBox
                key={item.value}
                name={item.value}
                label={item.label}
                checked={
                  Array.isArray(filters?.type) &&
                  filters?.type.includes(item?.value as filterStateDataType)
                }
                onChange={() =>
                  toggleMediaType(item.value as filterStateDataType)
                }
              />
            ))}
          </div>
        </div>
      </DropdownButton>
    </div>
  );
};

export default FileUploadFilter;
